export { default, type HotelsSectionProps } from './HotelsSection';
